import { Button, Flex } from "antd";
import { Title3 } from "components/Common/Typography/Titles";
import React from "react";
import BulkMailCandidate from "./BulkMailCandidate";

interface BulkMailHeaderProps {
    handleSendMail: () => void;
    isSending: boolean;
    candidates: any;
    selectedMails?: any;
}

const BulkMailHeader: React.FC<BulkMailHeaderProps> = ({ handleSendMail, isSending, candidates, selectedMails }) => {

    return (
        <Flex justify="space-between" className="pr-4 h-[51px] border-b bg-white" align="center">
            <Flex className="pl-6" gap={4} align="center">
                <BulkMailCandidate candidates={candidates} />

            </Flex>
            {/* <Flex align="center" gap={4}>
                <Button
                    type="primary"
                    onClick={handleSendMail}
                    loading={isSending}
                    icon={<svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M8.74928 11.2501L17.4993 2.50014M8.85559 11.5235L11.0457 17.1552C11.2386 17.6513 11.3351 17.8994 11.4741 17.9718C11.5946 18.0346 11.7381 18.0347 11.8587 17.972C11.9978 17.8998 12.0946 17.6518 12.2881 17.1559L17.78 3.08281C17.9547 2.63516 18.0421 2.41133 17.9943 2.26831C17.9528 2.1441 17.8553 2.04663 17.7311 2.00514C17.5881 1.95736 17.3643 2.0447 16.9166 2.21939L2.84349 7.71134C2.34759 7.90486 2.09965 8.00163 2.02739 8.14071C1.96475 8.26129 1.96483 8.40483 2.02761 8.52533C2.10004 8.66433 2.3481 8.7608 2.84422 8.95373L8.47589 11.1438C8.5766 11.183 8.62695 11.2026 8.66935 11.2328C8.70693 11.2596 8.7398 11.2925 8.7666 11.3301C8.79685 11.3725 8.81643 11.4228 8.85559 11.5235Z"
                            stroke="white"
                            strokeWidth="1.66667"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>}
                    disabled={selectedMails?.length === 0}
                >

                    Send Message
                </Button>
            </Flex> */}
        </Flex>
    );
};

export default BulkMailHeader;